<template>
<div> 
  <!-- {{form}} -->
  <v-stepper v-model="e1">
    <v-stepper-header>
      <v-stepper-step :complete="e1 > 1" step="1">Loan Profile {{form}} Entry</v-stepper-step>

      <v-divider></v-divider>
      <v-stepper-step :complete="e1 > 2" step="2">Loan Profile Entry - Document</v-stepper-step>

      <v-divider></v-divider>
      <v-stepper-step :complete="e1 > 3" step="2">Loan Schedule</v-stepper-step>      
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        
        <LoanResetForm v-if="form=='Reset'" v-on:emitForm1="goNextStep">          
        </LoanResetForm>

        <LoanReScheduleForm v-else-if="form=='Re-Schedule'" v-on:emitForm1="goNextStep">
        </LoanReScheduleForm>

        <LoanprofiePartialForm  v-else-if="form_name=='/on-lending/loan-profile-partialgraceperiodform'" v-on:emitForm1="goNextStep">          
        </LoanprofiePartialForm>

        <LoanProfileForm v-else v-on:emitForm1="goNextStep">          
        </LoanProfileForm>

      </v-stepper-content>

      <template v-if="e1==2">
      <v-stepper-content step="2">
        <ProjectDocument v-on:emitForm2="goNextStep"></ProjectDocument>
      </v-stepper-content>
      </template>

      <template v-if="e1==3">
      <v-stepper-content step="3">
        <LoanProfileSchedule v-on:emitForm3="goNextStep"></LoanProfileSchedule>
      </v-stepper-content>
      </template>
    
    </v-stepper-items>
  </v-stepper>
</div>
</template>

<script>
let commonService = require("../../../services/common.service");
import LoanProfileForm from './step_forms/loanProfileForm';
import LoanprofiePartialForm from './step_forms/loanprofiePartialForm';
import LoanResetForm from './step_forms/loanResetForm';
import LoanReScheduleForm from './step_forms/loanReScheduleForm';
import ProjectDocument from './step_forms/projectDocument';
import LoanProfileSchedule from './step_forms/loanProfileSchedule';
export default {
  components: {
    LoanProfileForm,
    LoanprofiePartialForm,
    LoanResetForm,
    LoanReScheduleForm,
    ProjectDocument,
    LoanProfileSchedule,
  },
  data() {
    return {
      e1: 0,
      //form: 'reset',
      formSchema: {
        pro_code: "",
        pro_start_date: "",
        pro_name: "",
        pro_name: "",
        pro_end_date: "",
        pro_objectives: "",
        pro_location: "",
        total_pro_v: "",
        adp_code: "",
        total_pro_v2: "",
        non_adp_code: "",
        pro_agreement_date: "",
        agreement_ministry: ""
      },
      form_name:this.$route.path
    };
  },
  created() {
    
  },
  methods:{
    goNextStep(num)
    {
      this.e1 = num
    }
  },

  computed:{
    form(){
      let common_data = this.$store.getters.GET_COMMON_DATA;       
      return (common_data.formName > 'Profile') ? common_data.formName : '';    
    }
  },


};
</script>


// WEBPACK FOOTER //
// src/components/lending/loanProfile/activitiesForm.vue